<template>
    <v-col align="start">
      <v-row no-gutters class="btn-group">
        <v-col cols="5">
          <v-btn 
            class="primary btn"  
            height="45"
            style="border-radius: 30px;"
            v-on:click="goBack">Go back
          </v-btn>
        </v-col>
      </v-row>
      <br/>
      <v-container>
        <v-row no-gutters>
          <v-col align="start">
            <h3 class="mb-4">Select furniture items below </h3>
          </v-col>
        </v-row>
        <v-row no-gutters class="mb-2" justify="start" align="start">
          <v-col>
            <v-list color="light" rounded outlined elevation="0">
              <v-list-group v-for="(name, i) in group_items" :key="i">
                <template v-slot:activator>
                  <v-list-item-title>
                    <h3> {{ name }} </h3>
                  </v-list-item-title>
                </template>
                <v-list-item>
                  <v-row no-gutters v-if="i === 0">
                    <v-col :cols="$vuetify.breakpoint.smAndDown ? '10' : '4'" v-for="(item, index) in living_room" :key="index">
                      <v-checkbox
                        v-model="selected_living_room_items"
                        :label="item"
                        color="primary"
                        :value="item"
                        dense
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row no-gutters v-if="i === 1">
                    <v-col :cols="$vuetify.breakpoint.smAndDown ? '10' : '4'" v-for="(item, index) in kitchen" :key="index">
                      <v-checkbox
                        v-model="selected_kitchen_items"
                        :label="item"
                        color="primary"
                        :value="item"
                        dense
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row no-gutters v-if="i === 2">
                    <v-col :cols="$vuetify.breakpoint.smAndDown ? '10' : '4'" v-for="(item, index) in bedrooom" :key="index">
                      <v-checkbox
                        v-model="selected_bedroom_items"
                        :label="item"
                        color="primary"
                        :value="item"
                        dense
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row no-gutters v-if="i === 3">
                    <v-col :cols="$vuetify.breakpoint.smAndDown ? '10' : '4'" v-for="(item, index) in dinning_room" :key="index">
                      <v-checkbox
                        v-model="selected_dinning_room_items"
                        :label="item"
                        color="primary"
                        :value="item"
                        dense
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row no-gutters v-if="i === 4">
                    <v-col :cols="$vuetify.breakpoint.smAndDown ? '10' : '4'" v-for="(item, index) in storage" :key="index">
                      <v-checkbox
                        v-model="selected_storage_items"
                        :label="item"
                        color="primary"
                        :value="item"
                        dense
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-divider class="py-3" v-if="i !== group_items.length - 1"></v-divider>
              </v-list-group>
            </v-list>
            <br/>
            <v-textarea
              outlined
              v-model="other_items"
              background-color="white"
              label="Other items"
              hint="Specify any items that was not mentioned above."
            ></v-textarea>
            <v-textarea
              outlined
              v-model="special_instructions"
              background-color="white"
              label="Special Instructions for the driver"
              hint="Specify instructions for the driver."
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-btn 
                    class="primary btn"  
                    height="45"
                    style="border-radius: 30px;"
                    :disabled="checkItems ? !canProceed : false"
                    v-on:click="proceed">Proceed
                </v-btn>
            </v-col>
            <span v-if="checkItems" class="error--text">
              Please make sure to select up to {{ serviceType.includes("6 items") ? "6 items" : "20 items" }} 
            </span>
        </v-row>
      </v-container>
    </v-col>
  </template>
  
  <script>
  export default {
    name: "ServicesBook",
    components:{
    },
    props: {
        goBack: Function,
        serviceType: {
          type: String,
          default: () => "",
        },
    },
    data() {
      return {
        selected_living_room_items: [],
        selected_bedroom_items: [],
        selected_kitchen_items: [],
        selected_dinning_room_items: [],
        selected_storage_items: [],
        other_items: "",
        special_instructions: "",
        group_items: [
          "Living room items",
          "Kitchen items",
          "Bedroom items",
          "Dinning room items",
          "Storage room items"
        ],
        living_room: [
          "Wall art / Mirrors",
          "TV stand / Entertainment unit",
          "Television",
          "Sofas",
          "1-seater couch/sofa",
          "2-seater couch/sofa",
          "3-seater couch/sofa",
          "sectional couch/sofa",
          "Sleeper Sofas",
          "Side tables",
          "Rugs / Carpets",
          "Recliners",
          "Ottoman",
          "Media devices (e.g. DVD player, game console)",
          "Floor lamps / Table lamps",
          "Display cabinets",
          "Cushions / Throws",
          "Curtains / Blinds",
          "Coffee table",
          "Ceiling light fitting / Fan",
          "Bookshelves",
          "Armchairs"
        ],
        bedrooom: [
          "Armchair / lounge chair",
          "Single bed base",
          "Double bed base",
          "Queen bed base",
          "King bed base",
          "Bedding sets (pillows, duvet, sheets)",
          "Beds Matress",
          "Bedside lamps",
          "Bedside tables (1 or 2 per room)",
          "Benches",
          "Bookshelf",
          "Chest of drawers",
          "Curtains / Blinds",
          "Desk and chair",
          "Dressing table / vanity",
          "Fan",
          "Headboards",
          "Heater / fan / portable aircon",
          "Laundry basket",
          "Mirror",
          "Rug / Carpet",
          "Wall art / framed pictures",
          "Wardrobe"
        ],
        kitchen: [
          "Airfryer",
          "Baker Racks",
          "Bar stools",
          "Cabinets",
          "Dish rack",
          "Dishwasher",
          "Fridge / Freezer",
          "Iron",
          "Ironing board",
          "Kitchen Islands",
          "Laundry baskets",
          "Microwave",
          "Pot Racks",
          "Storage shelves",
          "Stove / Oven",
          "Toaster / Kettle / Coffee machine",
          "Trash bin",
          "Tumble dryer / Drying rack",
          "Washing machine"
        ],
        dinning_room: [
          "Arm Chairs",
          "Bar and counter stools",
          "Console tables",
          "Curtains / Blinds",
          "Dining table",
          "Display cabinet",
          "Floor lamp",
          "Rug",
          "Sideboard / Buffet / Console table",
          "Desk and chair",
          "Dressing table / vanity",
          "Fan",
          "Headboards",
          "Heater / fan / portable aircon",
          "Laundry basket",
          "Mirror",
          "Rug / Carpet",
          "Wall art / framed pictures",
          "Wardrobe"
        ],
        storage: [
          "Bookcases",
          "Bookshelves",
          "Coat rack / Hooks",
          "Console table",
          "Desk",
          "Dorm Room Fridge Stand",
          "Filing cabinet / Drawer unit",
          "Footlockers",
          "Furniture",
          "Hall runner / rug",
          "Magazine Rack",
          "Mirror",
          "Office chair",
          "Shoe rack / bench",
          "Dressing table / vanity",
          "Fan",
          "Headboards",
          "Heater / fan / portable aircon",
          "Laundry basket",
          "Rug / Carpet",
          "Wall art / framed pictures",
          "Wardrobe"
        ],
      }
    },
    computed: {
      checkItems() {
        return this.serviceType.includes("6 items") || this.serviceType.includes("20 items");
      },
      canProceed() {
        let items = [
          ...this.selected_living_room_items,
          ...this.selected_bedroom_items,
          ...this.selected_kitchen_items,
          ...this.selected_dinning_room_items,
          ...this.selected_storage_items,
         ...(this.other_items.length > 0 ? [this.other_items] : []),
        ];

        if (this.serviceType.includes("6 items")) {
          return items.length > 0 && items.length <= 6;
        }
        else if (this.serviceType.includes("20 items")) {
          return items.length > 0 && items.length <= 20;
        }
        else {
          return null;
        }
      }
    },
    watch: {

    },
    methods: {
      scrollToTop(){
        setTimeout(() => {
          scroll(0, 0);
        }, 0)
      },
      proceed(){
        this.$emit("proceed", {
          selected_living_room_items: this.selected_living_room_items,
          selected_dinning_room_items: this.selected_dinning_room_items,
          selected_bedroom_items: this.selected_bedroom_items,
          selected_kitchen_items: this.selected_kitchen_items,
          selected_storage_items: this.selected_storage_items,
          other_items: this.other_items,
          special_instructions: this.special_instructions,
        })
      },
      reload(){
        this.$router.go();
      },

    },
    mounted() {
        
    }
  }
  </script>
  
  <style scoped>
  .btn{
    width: 200px;
  }
  @media screen and (max-width: 550px){
    .btn-group{
      display: block;
    }
    .btn{
      margin-bottom: 0.5cm;
    }
  
  }
  
  </style>